import React, { useEffect, useState, useCallback } from "react";
import "./Inventory.css";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import { AddCircleOutline } from "@mui/icons-material";
import {
  deleteProduct,
  getCategoryList,
  getProducts,
  bulkDeleteProducts,
} from "../../../Services/authService";
import ProductCard from "./ProductCard";
import ProductModal from "./ProductModal";
import SuccessNotification from "../../../Components/Common/SuccessNotification";
import CategoriesSlider from "./CategorySlider";
import CategoryModal from "./CategoryModal";
import DeleteConfirmationPopup from "../../../Components/Common/DeleteConfirmationPopup";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  Grid,
  TextField,
  InputAdornment,
  TablePagination,
  Stack,
  Typography,
} from "@mui/material";
import { DropDownIcon } from "../../../Components/Layouts/CustomIcons";
import LoadingAnimation from "../../../Components/Common/LoadingAnimation";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import temp1 from "../../../assets/ProductImage.webp";

function Inventory() {
  const { t } = useTranslation();
  const { mode } = useThemeContext();

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [priceOrder, setPriceOrder] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState(new Set());
  const [isBulkDeletePopupOpen, setIsBulkDeletePopupOpen] = useState(false);
  const [bulkDeleteError, setBulkDeleteError] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0);
  };
  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setPage(0);
  };
  const handleSortChange = (e) => {
    setPriceOrder(e.target.value);
    setPage(0);
  };

  const backgroundCard =
    mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const btnAddColor =
    mode === "dark" ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;
  const textColor =
    mode === "dark"
      ? DARKCOLORS.HeadingLightBackground
      : LIGHTCOLORS.HeadingLightBackground;
  const btnborderColor =
    mode === "dark" ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;
  const borderColor1 =
    mode === "dark" ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;
  const searchBackground =
    mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const dropIcon =
    mode === "dark" ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;
  const dangerColor =
    mode === "dark" ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
  const baseBlack =
    mode === "dark" ? DARKCOLORS.BaseBlack : LIGHTCOLORS.BaseBlack;
  const inputBoxColor =
    mode === "dark" ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;

  const handleOpenModal = () => {
    setSelectedProduct(null);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);

  const handleOpenModal1 = () => setIsModalOpen1(true);
  const handleCloseModal1 = () => setIsModalOpen1(false);

  const fetchCategories = useCallback(async () => {
    try {
      const categoryData = await getCategoryList();
      // console.log(categoryData);
      setCategories(categoryData);

      if (!categoryData || categoryData.length === 0) {
        setSelectedCategory(null);
        setProducts([]);
        return;
      }
       
      // console.log("categoryData =", categoryData);
    //  console.log("Is Array =", Array.isArray(categoryData));
      const selectedExists = categoryData.some(
        (cat) => cat.id === selectedCategory,
      );

      const newCategoryId = selectedExists
        ? selectedCategory
        : categoryData[0].id;

      // ✅ ONLY set category
      setSelectedCategory(newCategoryId);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, []);

  // Single source of truth for product fetching: all state changes drive this effect
  useEffect(() => {
    if (!selectedCategory) return;

    let cancelled = false;

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const productData = await getProducts(
          page,
          rowsPerPage,
          selectedCategory,
          searchTerm,
          priceOrder,
          statusFilter,
        );
        if (!cancelled) {
          setProducts(productData.content || []);
          setTotalRows(productData.totalElements || 0);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching products:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchProducts();

    return () => {
      cancelled = true;
    };
  }, [
    selectedCategory,
    page,
    rowsPerPage,
    searchTerm,
    priceOrder,
    statusFilter,
    refreshTrigger,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
  };

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  // Clear selection when navigating (page, category, filters change)
  useEffect(() => {
    setSelectedProductIds(new Set());
  }, [
    selectedCategory,
    page,
    rowsPerPage,
    searchTerm,
    priceOrder,
    statusFilter,
  ]);

  const handleProductClick = (product) => {
    setSelectedProduct(product); // Update the state with the selected product
    setIsModalOpen(true);
  };

  const handleCloseNotification = () => {
    setNotificationOpen(false);
    setSuccessMessage("");
  };

  // Handle category change — state updates will drive the fetch via useEffect
  const handleCategoryChange = (newCategoryId) => {
    setSelectedCategory(newCategoryId);
    setPage(0);
    setRefreshTrigger((prev) => prev + 1); // Force re-fetch even if same category
  };

  // After product update: refresh current category WITHOUT navigating to the new category
  const handleProductUpdated = useCallback(() => {
    setPage(0);
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  // Toggle selection mode on/off
  const handleToggleSelectionMode = () => {
    setSelectionMode((prev) => {
      if (prev) {
        // Turning off: clear all selections
        setSelectedProductIds(new Set());
      }
      return !prev;
    });
  };

  // Toggle a single product in the selection set
  const handleProductSelect = (productId) => {
    setSelectedProductIds((prev) => {
      const updated = new Set(prev);
      updated.has(productId)
        ? updated.delete(productId)
        : updated.add(productId);
      return updated;
    });
  };

  // Select or deselect all products on the current page
  const handleSelectAll = () => {
    const allIds = products.map((p) => p.productId);
    const allSelected =
      allIds.length > 0 && allIds.every((id) => selectedProductIds.has(id));
    if (allSelected) {
      // Deselect all on current page
      setSelectedProductIds((prev) => {
        const updated = new Set(prev);
        allIds.forEach((id) => updated.delete(id));
        return updated;
      });
    } else {
      // Select all on current page
      setSelectedProductIds((prev) => {
        const updated = new Set(prev);
        allIds.forEach((id) => updated.add(id));
        return updated;
      });
    }
  };

  // Open bulk delete confirmation
  const handleBulkDeleteClick = () => {
    setBulkDeleteError("");
    setIsBulkDeletePopupOpen(true);
  };

  const handleCloseBulkDeletePopup = () => {
    setIsBulkDeletePopupOpen(false);
    setBulkDeleteError("");
  };

  // Perform bulk deletion of all selected products
  const handleConfirmBulkDelete = async () => {
    if (selectedProductIds.size === 0) return;

    try {
      setLoading(true);
      setBulkDeleteError("");
      const idsToDelete = Array.from(selectedProductIds);
      // Single batch delete call instead of one-by-one
      await bulkDeleteProducts(idsToDelete);
      // Success: clear selection, close popup, refresh
      setSelectedProductIds(new Set());
      setIsBulkDeletePopupOpen(false);
      setSuccessMessage(
  t('inventory.bulkDeleteSuccess', { count: idsToDelete.length })
);

setNotificationOpen(true);
setSelectionMode(false);
setRefreshTrigger((prev) => prev + 1);
setPage(0);
    } catch (error) {
      console.error("Error during bulk delete:", error);
      setBulkDeleteError(t("inventory.FailedToDeleteProduct"));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (row) => {
    setErrorMessage(""); // Clear any stale error from previous delete
    setIsDeletePopupOpen(true);
  };

  const handleCloseDeletePopup = () => {
    setIsDeletePopupOpen(false);
    setErrorMessage(""); // Clear error when closing
  };

  const handleConfirmDelete = async () => {
    if (!selectedProduct) return;

    try {
      setLoading(true);
      await deleteProduct(selectedProduct.productId);
      setSuccessMessage(t("inventory.deletedSuccessfully"));
      setNotificationOpen(true);
      setRefreshTrigger((prev) => prev + 1); // Force re-fetch after delete
      setPage(0);
      handleCloseDeletePopup();
      handleCloseModal();
    } catch (error) {
      setErrorMessage(t("inventory.FailedToDeleteProduct"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-container">
      {loading && <LoadingAnimation />}
      {/* Heading & btns */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <h2 className="membership-text-heading" style={{ margin: "0px" }}>
          {t("inventory.inventory")}
        </h2>

        <Box id="categoryProduct">
          {/* Category btn */}
          <IconButton
            className="add-machine"
            onClick={handleOpenModal1}
            sx={{
              borderRadius: "40px",
              gap: 1.5,
              padding: "11px 20px",
              border: `1px solid ${btnborderColor}`,
              backgroundColor: "transparent",
              mx: "7px",
              "&:hover": {
                backgroundColor: "transparent", // Same as default
                boxShadow: "none", // Prevent shadow effects
              },
            }}
          >
            {t("inventory.categories")}
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M7.00033 9.91667V11.305C7.00033 12.3958 6.56283 12.8333 5.46616 12.8333H2.69533C1.60449 12.8333 1.16699 12.3958 1.16699 11.305V8.53417C1.16699 7.4375 1.60449 7 2.69533 7H4.08366V8.3825C4.08366 9.47917 4.52116 9.91667 5.61199 9.91667H7.00033Z"
                  stroke={textColor}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.91634 7.00065V8.38315C9.91634 9.47982 9.47884 9.91732 8.38217 9.91732H5.61134C4.52051 9.91732 4.08301 9.47982 4.08301 8.38315V5.61232C4.08301 4.52148 4.52051 4.08398 5.61134 4.08398H6.99967V5.46648C6.99967 6.56315 7.43717 7.00065 8.52801 7.00065H9.91634Z"
                  stroke={textColor}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.8333 2.69435V5.46518C12.8333 6.56185 12.3958 6.99935 11.2992 6.99935H8.52833C7.4375 6.99935 7 6.56185 7 5.46518V2.69435C7 1.60352 7.4375 1.16602 8.52833 1.16602H11.2992C12.3958 1.16602 12.8333 1.60352 12.8333 2.69435Z"
                  stroke={textColor}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </IconButton>

          {/* Product btn */}
          <IconButton
            className="add-machine"
            onClick={handleOpenModal}
            sx={{
              borderRadius: "40px",
              padding: "11px 20px",
              backgroundColor: btnAddColor,
              color: "#000",
              mx: "7px",
              "&:hover": {
                backgroundColor: btnAddColor, // Same as default
                color: "#000", // Same as default
                boxShadow: "none", // Prevent shadow effects
              },
            }}
          >
            {t("inventory.addProduct")}{" "}
            <AddCircleOutline fontSize="small" sx={{ marginLeft: "10px" }} />
          </IconButton>
        </Box>
      </Box>

      {/* Categories Slider */}
      <CategoriesSlider
        categories={categories}
        selectedCategory={selectedCategory}
        sendSelectedCategory={(category) => handleCategoryChange(category.id)}
      />

      <Box
        sx={{
          background: backgroundCard,
          p: 5,
          margin: "20px 0px",
          borderRadius: "12px",
        }}
      >
        <Box
          className="inventory-search-sec"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
            mb: 3,
          }}
        >
          {/* Search Bar */}
          <TextField
            className="inventory-search-Bar"
            placeholder={t("inventory.searchByName")}
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              borderRadius: "24px",
              background: searchBackground,
              width: "calc(12rem + 12vw)",
            }}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none", // Removes the border from the outline
                },
              },
            }}
          />

          <Box
            className="inventory-filter-sec"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            {/* Select Mode Toggle btn */}
            <IconButton
              className="add-machine inventory-btns margin-zero"
              onClick={handleToggleSelectionMode}
              sx={{
                borderRadius: "40px",
                padding: "9px 20px",
                mx: "7px",
                rippleEffect: false,
                backgroundColor: "transparent",
                color: selectionMode ? dangerColor : textColor,
                border: `1px solid ${selectionMode ? dangerColor : btnborderColor}`,
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
              }}
            >
              {selectionMode ? t("inventory.cancel") : t("inventory.select")}
              {selectionMode ? null : (
                <CheckBoxOutlineBlankIcon
                  fontSize="small"
                  sx={{ marginLeft: "6px" }}
                />
              )}
            </IconButton>
            {/* filter */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <Select 

                value={statusFilter}
                onChange={handleStatusFilterChange}
                displayEmpty
                size="small"
                IconComponent={(props) => (
                  <DropDownIcon
                    color1={btnborderColor}
                    color2={dropIcon}
                    {...props}
                  />
                )} // Use the custom DropDownIcon component
                sx={{
                  borderRadius: "24px",
                  border: `0px solid ${borderColor1}`,
                  textAlign: "center",
                  paddingRight: "12px",
                  "& .MuiSelect-select": {
                    padding: "9px 20px 9px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `0.5px solid ${borderColor1}`,
                  },
                  "@media (max-width: 500px)": {
                    fontSize: "12px", // Full width on small screens
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "16px",
                      border: `0px solid ${borderColor1}`,
                      boxShadow: "none",
                      backgroundColor: backgroundCard,
                      padding: "10px",
                      marginTop: "10px",
                    },
                  },
                }}
                renderValue={(selected) => {
                  if (selected === "") {
                    return (
                      <p className="sort-filter-text inventory-btn-text">
                        {t("membershipCards.filter")}
                      </p>
                    ); // Show "Sort" as placeholder when no value selected
                  }
                  const filterLabels = {
                    Vegan: "inventory.Vegan",
                    Vegetarian: "inventory.Vegetarian",
                    "Fish-Free": "inventory.Fish",
                    "Gluten-Free": "inventory.Gluten",
                    "Lactose-Free": "inventory.Lactose",
                    "High Protein": "inventory.Protein",
                  };
                  return t(filterLabels[selected]) || selected;
                }}
              >
                <MenuItem className="menu-item-sec" value="">
                  {t("membershipCards.all")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="Vegan">
                  {" "}
                  {t("inventory.Vegan")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="Vegetarian">
                  {" "}
                  {t("inventory.Vegetarian")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="Fish-Free">
                  {" "}
                  {t("inventory.Fish")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="Gluten-Free">
                  {" "}
                  {t("inventory.Gluten")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="Lactose-Free">
                  {t("inventory.Lactose")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="High Protein">
                  {t("inventory.Protein")}
                </MenuItem>
              </Select>
            </Box>

            {/* Sort */}
            <Box sx={{ display: "flex", gap: 2 }}>
              <Select
                value={priceOrder}
                onChange={handleSortChange}
                displayEmpty
                size="small"
                IconComponent={(props) => (
                  <DropDownIcon
                    color1={btnborderColor}
                    color2={dropIcon}
                    {...props}
                  />
                )} // Use the custom DropDownIcon component
                sx={{
                  borderRadius: "24px",
                  border: `0px solid ${borderColor1}`,
                  textAlign: "center",
                  paddingRight: "12px",
                  "& .MuiSelect-select": {
                    padding: "9px 20px 9px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `0.5px solid ${borderColor1}`,
                  },
                  "@media (max-width: 500px)": {
                    fontSize: "12px", // Full width on small screens
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "16px",
                      border: `0px solid ${borderColor1}`,
                      boxShadow: "none",
                      backgroundColor: backgroundCard,
                      padding: "10px",
                      marginTop: "10px",
                    },
                  },
                }}
                renderValue={(selected) => {
                  if (selected === "") {
                    return (
                      <p className="inventory-btn-text sort-filter-text ">
                        {t("membershipCards.sort")}
                      </p>
                    ); // Show "Sort" as placeholder when no value selected
                  }
                  if (selected === "ascending") return t("inventory.low2high");
                  if (selected === "descending") return t("inventory.high2low");
                  return selected;
                }}
              >
                <MenuItem className="menu-item-sec" value="">
                  {t("membershipCards.all")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="ascending">
                  {t("inventory.low2high")}
                </MenuItem>
                <MenuItem className="menu-item-sec" value="descending">
                  {t("inventory.high2low")}
                </MenuItem>
              </Select>
            </Box>
          </Box>
        </Box>

        {/* Products List */}
        {loading ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              margin: "20px",
              justifyContent: "center",
              alignSelf: "center",
              textAlign: "center",
            }}
          >
            {/* <p>{t('vendingMachines.Loading')}</p> */}
            <p>{t("inventory.LoadingProducts")}</p>
            {/* // Show loading text while fetching products */}
          </Box>
        ) : (
          <div>
            {/* Product in Row */}
            {products.length > 0 ? (
              <Grid container item spacing={3}>
                {products.map((product) => (
                  <Grid   className="grid-item" 
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={product.productId}
                  >
                    <ProductCard
                      product={product}
                      sendSelectedCard={handleProductClick}
                      selectionMode={selectionMode}
                      isSelected={selectedProductIds.has(product.productId)}
                      onSelect={handleProductSelect}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  margin: "20px",
                  justifyContent: "center",
                  alignSelf: "center",
                  textAlign: "center",
                }}
              >
                <p>{t("inventory.NoProductsFound")}</p>
              </Box>
            )}
          </div>
        )}
        {/* Pagination */}
        <TablePagination
          component="div"
          count={totalRows}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t("membershipCards.RowsPerPage", "Rows Per Page")}
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </Box>

      {/* Floating Action Bar for bulk delete */}
      {selectionMode && (
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            position: "fixed",
            bottom: 24,
            left: "55%",
            zIndex: 1000,
            transform:
              selectedProductIds.size > 0
                ? "translateX(-50%) translateY(0) scale(1)"
                : "translateX(-50%) translateY(100%) scale(0)",
            opacity: selectedProductIds.size > 0 ? 1 : 0,
            transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
            backgroundColor:
              mode === "dark"
                ? "rgba(30, 30, 30, 0.8)"
                : "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(12px)",
            borderRadius: "16px",
            padding: "8px 16px",
            boxShadow:
              mode === "dark"
                ? "0 4px 30px rgba(0, 0, 0, 0.5)"
                : "0 4px 30px rgba(0, 0, 0, 0.1)",
            border: `1px solid ${mode === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)"}`,
            pointerEvents: selectedProductIds.size > 0 ? "auto" : "none",
            "@media (max-width: 426px)": {
              bottom: "auto",
              top: 24,
              transform:
                selectedProductIds.size > 0
                  ? "translateX(-50%) translateY(0) scale(1)"
                  : "translateX(-50%) translateY(-100%) scale(0)",
            },
          }}
        >
          {/* Select All / Deselect All (visible in selection mode) */}
          {selectionMode && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleSelectAll}
              startIcon={
                products.length > 0 &&
                products.every((p) => selectedProductIds.has(p.productId)) ? (
                  <CheckBoxIcon />
                ) : (
                  <CheckBoxOutlineBlankIcon />
                )
              }
              sx={{
                borderRadius: "24px",
                textTransform: "none",
                // borderColor: btnborderColor,
                // padding: 'px 10px',
                border: "none",
                color: textColor,
                whiteSpace: "nowrap",
                "&:hover": {
                  borderColor: btnborderColor,
                  backgroundColor: "transparent",
                },
              }}
            >
              {t('inventory.selectAll')}
            </Button>
          )}

          <Typography sx={{ color: textColor, fontWeight: 500, whiteSpace: "nowrap" }}>
            {t('inventory.selectedCount', { count: selectedProductIds.size })}
          </Typography>
          <Button
            variant="outlined"
            color="error"
            onClick={handleBulkDeleteClick}
            disabled={selectedProductIds.size === 0}
            sx={{
              borderWidth: 2,
              borderColor: dangerColor,
              textTransform: "none",
              backgroundColor: dangerColor,
              borderRadius: "24px",
              px: 2.5,
              py: 0.75,
              color: textColor,
            }}
          >
            {t('inventory.delete')}
          </Button>
        </Stack>
      )}

      <CategoryModal
        open={isModalOpen1}
        onClose={handleCloseModal1}
        categories={categories}
        fetchCategories={fetchCategories}
      />

      {/* Modal Popup */}
      <ProductModal
        open={isModalOpen}
        categories={categories}
        products={products}
        onClose={handleCloseModal}
        fetchProductsByCategory={handleCategoryChange}
        selectedProduct={selectedProduct}
        handleDeleteClick={handleDeleteClick}
        onProductUpdated={handleProductUpdated}
      />

      {/* Success Notification */}
      <SuccessNotification
        open={notificationOpen}
        message={successMessage}
        onClose={handleCloseNotification}
      />

      {/* Single Delete Confirmation Popup */}
      <DeleteConfirmationPopup
        open={isDeletePopupOpen}
        onClose={handleCloseDeletePopup}
        heading={t("inventory.deleteConfirmHeading")}
        message={t("inventory.deleteConfirmMessage")}
        onConfirm={handleConfirmDelete}
        itemName={`(${selectedProduct?.productId})`}
        errorMessage={errorMessage}
      />

      {/* Bulk Delete Confirmation Popup */}
      <DeleteConfirmationPopup
        open={isBulkDeletePopupOpen}
        onClose={handleCloseBulkDeletePopup}
        heading={t('inventory.bulkDeleteConfirmHeading')}
        message={t('inventory.bulkDeleteConfirmMessage', { count: selectedProductIds.size })}
        onConfirm={handleConfirmBulkDelete}
        errorMessage={bulkDeleteError}
      />
    </div>
  );
}

export default Inventory;
